import { render, staticRenderFns } from "./LampiranSKP.vue?vue&type=template&id=940ea5ce&scoped=true&lang=html&"
import script from "./LampiranSKP.vue?vue&type=script&lang=js&"
export * from "./LampiranSKP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940ea5ce",
  null
  
)

export default component.exports